import { useQuery } from '@apollo/client/react/hooks';

import query from './query.graphql';

export const usePollJobHistoryForStatus = ({
  onCompleted,
  jobId,
  minTimestamp,
  status,
}) => {
  const { stopPolling: stopJobHistoryPolling } = useQuery(query, {
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
    onCompleted(jobHistoryData) {
      const jobHistory = jobHistoryData?.jobHistory;
      if (
        jobHistory &&
        jobHistory?.status == status &&
        new Date(jobHistory.timestamp) > new Date(minTimestamp)
      ) {
        onCompleted();
        stopJobHistoryPolling();
      }
    },
    skip: !jobId,
    pollInterval: 500,
    variables: {
      jobId: jobId,
    },
  });
};
